import { DeleteOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Input, Row, Space, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useClient } from "../../../Context/ClientContext";

const AddBids = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { currentClient } = useClient();
  const dataSource = [
    {
      key: "1",
      productName: "Computer",
      HSN: 324,
      variant: "Lenovo",
      requiredQty: 5,
    },
  ];

  const columns: ColumnsType<any> = [
    {
      title: "HSN",
      dataIndex: "HSN",
      key: "HSN",
      width: "10%",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
    },
    {
      title: "Specifications / Variant",
      dataIndex: "variant",
      key: "variant",
    },
    {
      title: "Required Qty",
      dataIndex: "requiredQty",
      key: "requiredQty",
    },

    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",

      render: () => (
        <>
          <Space>
            <Button
              style={{ padding: "1px 5px" }}
              // onClick={() => setIsModelOpen(true)}
              size="small"
            >
              <EyeOutlined />
            </Button>
            <Button
              style={{ padding: "1px 5px" }}
              // onClick={() => setIsModelOpen(true)}
              size="small"
            >
              <DeleteOutlined />
            </Button>
          </Space>
        </>
      ),
    },
  ];
  return (
    <>
      <div>
        <Card size="small">
          <Form form={form} layout="vertical">
            <Form.Item label="Bid Name">
              <Input />
            </Form.Item>

            <Card size="small">
              <Table
                columns={columns}
                dataSource={dataSource}
                size="middle"
                style={{ marginTop: "10px" }}
                pagination={false}
              />
            </Card>
            <Row justify={"end"} style={{ marginTop: "10px" }}>
              <Col>
                <Button
                  icon={<PlusOutlined />}
                  type="primary"
                  onClick={() =>
                    navigate(
                      `/inventory/clients/${currentClient?.id}/bids/info`
                    )
                  }
                >
                  Add Product
                </Button>
              </Col>
            </Row>
            <Card
              title="Fulfilled Information"
              style={{ width: "100%", margin: "15px 0px" }}
              type="inner"
            >
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item label="Fulfilled By Date">
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item label="Fulfillment Location">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    label="Required Documents"
                    style={{ marginBottom: "5px" }}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    label="Terms & Conditions"
                    style={{ marginBottom: "5px" }}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Card
              size="default"
              title="Bid Information"
              style={{ width: "100%", margin: "15px 0px" }}
              type="inner"
            >
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item label="Bid For">
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item label="Start Date & Time">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item
                    label="Required Documents"
                    style={{ marginBottom: "5px" }}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col sm={12} xs={24} lg={12} xl={12}>
                  <Form.Item label="Comment" style={{ marginBottom: "5px" }}>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Form>
          <Row justify={"end"} style={{ marginTop: "10px" }} gutter={20}>
            <Col>
              <Button type="primary">Publish Bid</Button>
            </Col>
            <Col>
              <Button>Cancel</Button>
            </Col>
          </Row>
        </Card>
      </div>
    </>
  );
};

export default AddBids;
